import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'auth-google-sign-in-button',
  templateUrl: './google-sign-in-button.component.html',
  styleUrls: ['./google-sign-in-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GoogleSignInButtonComponent {
  @Input() loading: boolean = false;
  @Input() label: string = 'Kontynuuj z Google';

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  onClick(): void {
    if (this.loading) {
      return;
    }
    this.clicked.emit();
  }
}
